import React, { useState } from "react";
import { openQRLabelPrint } from "../../utils/qrLabelPrint";

export default function PrintQRButton({ asset }) {
  const [busy, setBusy] = useState(false);
  const print = async () => {
    setBusy(true);
    try {
      await openQRLabelPrint(asset);
    } catch (error) {
      window.alert(error.message || "Unable to prepare the QR label. Please try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" className="btn btn-dark"
      style={{ whiteSpace: "nowrap", borderRadius: "8px" }}
      disabled={busy || !asset?.trackingId}
      title="Print a 50 mm wide × 30 mm high QR sticker"
      onClick={print}>
      <i className="fas fa-print" aria-hidden="true" /> {busy ? "Preparing..." : "Print QR"}
    </button>
  );
}
